import isMobile from "@/mixins/isMobile";

export default {
  mixins: [isMobile],
  data() {
    return {
      itemsPerPage: 25,
      currentPage: 1,
    };
  },
  computed: {
    footerProps() {
      const footerProps = {
        itemsPerPageOptions: [10, 25, 50, -1],
        showCurrentPage: true,
        showFirstLastPage: true,
      };
      if (this.isMobile) {
        footerProps.itemsPerPageOptions = [10];
      }
      return footerProps;
    },
  },
  watch: {
    isMobile(val) {
      if (val) {
        this.setItemsPerPage(10);
      } else {
        this.setItemsPerPage(25);
      }
    },
  },
  methods: {
    scrollTabletoTop() {
      const table = this.$refs["dataTable"];
      const wrapper = table.$el.querySelector("div.v-data-table__wrapper");
      this.$vuetify.goTo(table, { container: wrapper, duration: 0 });
    },
    setItemsPerPage(amount) {
      this.itemsPerPage = amount;
    },
    setCurrentPage(num) {
      this.currentPage = num;
    },
  },
};
